import { useCallback, useMemo, useState } from 'react';
import { useGradeLevels } from './use-grade-levels';

export const useGradYearState = (initialState = undefined) => {
    const {
        gradYears,
    } = useGradeLevels();

    const gradYearStateMapDefault = useMemo(
        () => gradYears
            .reduce((gradYearStateMap, gradYear) => ({ ...gradYearStateMap, [gradYear]: initialState }), {}),
        [gradYears]
    );

    const [ gradYearStateMap, setGradYearStateMap ] = useState(gradYearStateMapDefault);

    const setGradYearState = useCallback(
        (gradYear, state) => setGradYearStateMap(gradYearStateMap => ({ ...gradYearStateMap, [gradYear]: state })),
        []
    );

    const getGradYearState = useCallback((gradYear) => gradYearStateMap[gradYear], [gradYearStateMap]);

    const resetGradYearStates = useCallback(
        () => setGradYearStateMap(gradYearStateMapDefault),
        [gradYearStateMapDefault]
    );

    return {
        gradYears,
        getGradYearState,
        setGradYearState,
        resetGradYearStates,
        gradYearStateMap
    };
};
